import { Button, Flex } from '@chakra-ui/react';
import { MouseEvent, useCallback } from 'react';

import { AutoCompleteInputItemProps } from './AutoCompleteInput.types';
import { useAutoCompleteContext } from './AutoCompleteInputContext';

export const AutoCompleteInputItem = ({ children, value }: AutoCompleteInputItemProps) => {
  const { addSelectedId } = useAutoCompleteContext();
  const handleClick = useCallback(() => addSelectedId(value), [value, addSelectedId]);

  // Prevent blur event triggering on the input element - otherwise, will close the list before the option is clicked
  const handleMouseDown = useCallback((e: MouseEvent<HTMLDivElement>) => e.preventDefault(), []);

  if (value === undefined || value === null) return null;

  return (
    <Flex
      as={Button}
      tabIndex={-1}
      variant='ghost'
      aria-label='Autocomplete Input Item'
      gap='2'
      p='2'
      width='full'
      justifyContent={'flex-start'}
      borderRadius='none'
      _hover={{
        backgroundColor: 'brand.100',
      }}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
    >
      {children}
    </Flex>
  );
};

AutoCompleteInputItem.displayName = 'AutoCompleteInputItem';
